import React from "react";
import {
  Divider,
  Box,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Typography,
} from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import TaskOutlinedIcon from "@mui/icons-material/TaskOutlined";
import { useTranslation } from "react-i18next";
import FeedbackIcon from "@mui/icons-material/Feedback";
import logo from "../../img/logo-v.png";
import "./DemoResultaten.css";

const Alert = () => {
  return (
    <svg
      width="14"
      height="14"
      viewBox="0 0 14 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7 0C8.85652 0 10.637 0.737498 11.9497 2.05025C13.2625 3.36301 14 5.14348 14 7C14 8.85652 13.2625 10.637 11.9497 11.9497C10.637 13.2625 8.85652 14 7 14C5.14348 14 3.36301 13.2625 2.05025 11.9497C0.737498 10.637 0 8.85652 0 7C0 5.14348 0.737498 3.36301 2.05025 2.05025C3.36301 0.737498 5.14348 0 7 0ZM7 2.69231C6.5524 2.69231 6.19231 3.0524 6.19231 3.5V7.26923C6.19231 7.71683 6.5524 8.07692 7 8.07692C7.4476 8.07692 7.80769 7.71683 7.80769 7.26923V3.5C7.80769 3.0524 7.4476 2.69231 7 2.69231ZM8.07692 10.2308C8.07692 9.94515 7.96346 9.67123 7.7615 9.46927C7.55954 9.26731 7.28562 9.15385 7 9.15385C6.71438 9.15385 6.44046 9.26731 6.2385 9.46927C6.03654 9.67123 5.92308 9.94515 5.92308 10.2308C5.92308 10.5164 6.03654 10.7903 6.2385 10.9923C6.44046 11.1942 6.71438 11.3077 7 11.3077C7.28562 11.3077 7.55954 11.1942 7.7615 10.9923C7.96346 10.7903 8.07692 10.5164 8.07692 10.2308Z"
        fill="#E54344"
      />
    </svg>
  );
};

const Warning = () => {
  return (
    <svg
      width="14"
      height="14"
      viewBox="0 0 12 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M6 12C7.5913 12 9.11742 11.3679 10.2426 10.2426C11.3679 9.11742 12 7.5913 12 6C12 4.4087 11.3679 2.88258 10.2426 1.75736C9.11742 0.632141 7.5913 0 6 0C4.4087 0 2.88258 0.632141 1.75736 1.75736C0.632141 2.88258 0 4.4087 0 6C0 7.5913 0.632141 9.11742 1.75736 10.2426C2.88258 11.3679 4.4087 12 6 12ZM5.0625 7.875H5.625V6.375H5.0625C4.75078 6.375 4.5 6.12422 4.5 5.8125C4.5 5.50078 4.75078 5.25 5.0625 5.25H6.1875C6.49922 5.25 6.75 5.50078 6.75 5.8125V7.875H6.9375C7.24922 7.875 7.5 8.12578 7.5 8.4375C7.5 8.74922 7.24922 9 6.9375 9H5.0625C4.75078 9 4.5 8.74922 4.5 8.4375C4.5 8.12578 4.75078 7.875 5.0625 7.875ZM6 3C6.19891 3 6.38968 3.07902 6.53033 3.21967C6.67098 3.36032 6.75 3.55109 6.75 3.75C6.75 3.94891 6.67098 4.13968 6.53033 4.28033C6.38968 4.42098 6.19891 4.5 6 4.5C5.80109 4.5 5.61032 4.42098 5.46967 4.28033C5.32902 4.13968 5.25 3.94891 5.25 3.75C5.25 3.55109 5.32902 3.36032 5.46967 3.21967C5.61032 3.07902 5.80109 3 6 3Z"
        fill="#FF8C00"
      />
    </svg>
  );
};

const NoRisk = () => {
  return (
    <svg
      width="14"
      height="14"
      viewBox="0 0 14 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7 0C8.85652 0 10.637 0.737498 11.9497 2.05025C13.2625 3.36301 14 5.14348 14 7C14 8.85652 13.2625 10.637 11.9497 11.9497C10.637 13.2625 8.85652 14 7 14C5.14348 14 3.36301 13.2625 2.05025 11.9497C0.737498 10.637 0 8.85652 0 7C0 5.14348 0.737498 3.36301 2.05025 2.05025C3.36301 0.737498 5.14348 0 7 0ZM10.8029 5.41827C11.1192 5.10192 11.1192 4.59039 10.8029 4.2774C10.4865 3.96442 9.975 3.96106 9.66202 4.2774L5.92644 8.01298L4.34471 6.43125C4.02837 6.1149 3.51683 6.1149 3.20385 6.43125C2.89087 6.7476 2.8875 7.25913 3.20385 7.57212L5.35769 9.72596C5.67404 10.0423 6.18558 10.0423 6.49856 9.72596L10.8029 5.41827Z"
        fill="#27CA40"
      />
    </svg>
  );
};

const DemoSummary = ({
  checks,
  request,
  setShowDeleteModal,
  setShowModalError,
  setSelectedCheck,
}) => {
  const { t, i18n } = useTranslation();

  return (
    <div className="summary-container">

      <div className="summary-container-l">
        {/* HIGH RISK FINDINGS */}
        <div className="summary-container-single">
          <Accordion
            sx={{
              boxShadow: "none",
              background: "#fff",
              "&.MuiAccordion-root:before": {
                display: "none",
              },
              "& .MuiAccordionSummary-root": {
                borderBottom: "none",
              },
            }}
            disableGutters
            defaultExpanded
          >
            <AccordionSummary
              expandIcon={<ExpandMoreIcon sx={{ color: "#454545" }} />}
              aria-controls="panel1-content"
              id="panel1-header"
              sx={{ padding: 0 }}
            >
              <Typography
                sx={{
                  display: "flex",
                  gap: "8px",
                  alignItems: "center",
                  fontSize: "16px",
                  fontWeight: 500,
                }}
                component="span"
              >
                <h1 className="overzicht-header alert">
                  {t("Pas op")} (
                  {
                    checks.filter(
                      (check) =>
                        check.textInstanceResults.length !== 0 &&
                        check.textInstanceResults.some(
                          (result) =>
                            result.variableOptionInstance.riskLevel === 2
                        )
                    ).length
                  }
                  )
                </h1>
              </Typography>
            </AccordionSummary>
            <AccordionDetails
              sx={{
                display: "flex",
                flexDirection: "column",
                gap: "16px",
                padding: "8px 0px",
              }}
            >
              {checks.filter(
                (check) =>
                  check.textInstanceResults.length !== 0 &&
                  check.textInstanceResults.some(
                    (result) => result.variableOptionInstance.riskLevel === 2
                  )
              ).length === 0 && (
                <span className="summary-check-result">
                  ({t("Geen gevonden")})
                </span>
              )}
              <div className="summary-box-container">
                {checks
                  .filter(
                    (check) =>
                      check.textInstanceResults.length !== 0 &&
                      check.textInstanceResults.some(
                        (result) =>
                          result.variableOptionInstance.riskLevel === 2
                      )
                  )
                  .map((check, index) => (
                    <div className="summary-result-single" key={index}>
                      <div className="summary-result-l">
                        <Typography
                          sx={{
                            display: "flex",
                            gap: "8px",
                            alignItems: "center",
                            fontSize: "16px",
                            fontWeight: 500,
                          }}
                          component="span"
                        >
                          <Alert />
                          <span>{t(`check.${check.name}`)}</span>
                        </Typography>
                        {check.textInstanceResults.length !== 0 && (
                          <span className="summary-check-result">
                            {i18n.language === "nl"
                              ? check.variableResult?.summaryNL ||
                                t("nietGevonden")
                              : check.variableResult?.summaryEN ||
                                t("nietGevonden")}
                          </span>
                        )}
                      </div>
                      <div className="summary-result-r">
                        <span
                          className="check-redirect alert"
                          onClick={() => setSelectedCheck(check)}
                        >
                          {t("klikVoorDetails")}
                        </span>
                      </div>
                    </div>
                  ))}
              </div>

              {/* MEDIUM RISK FINDINGS */}
            </AccordionDetails>
          </Accordion>
        </div>

        {/* MEDIUM RISK FINDINGS */}
        <div className="summary-container-single">
          <Accordion
            sx={{
              boxShadow: "none",
              background: "#fff",
              "&.MuiAccordion-root:before": {
                display: "none",
              },
              "& .MuiAccordionSummary-root": {
                borderBottom: "none",
              },
            }}
            disableGutters
            defaultExpanded
          >
            <AccordionSummary
              expandIcon={<ExpandMoreIcon sx={{ color: "#454545" }} />}
              aria-controls="panel1-content"
              id="panel1-header"
              sx={{ padding: 0 }}
            >
              <Typography
                sx={{
                  display: "flex",
                  gap: "8px",
                  alignItems: "center",
                  fontSize: "16px",
                  fontWeight: 500,
                }}
                component="span"
              >
                <h1 className="overzicht-header warning">
                  {t("Let op")} (
                  {
                    checks.filter(
                      (check) =>
                        check.textInstanceResults.length !== 0 &&
                        check.textInstanceResults.some(
                          (result) =>
                            result.variableOptionInstance.riskLevel === 1
                        )
                    ).length
                  }
                  )
                </h1>
              </Typography>
            </AccordionSummary>
            <AccordionDetails
              sx={{
                display: "flex",
                flexDirection: "column",
                gap: "16px",
                padding: "8px 0px",
              }}
            >
              {checks.filter(
                (check) =>
                  check.textInstanceResults.length !== 0 &&
                  check.textInstanceResults.some(
                    (result) => result.variableOptionInstance.riskLevel === 1
                  )
              ).length === 0 && (
                <span className="summary-check-result">
                  ({t("Geen gevonden")})
                </span>
              )}
              <div className="summary-box-container">
                {checks
                  .filter(
                    (check) =>
                      check.textInstanceResults.length !== 0 &&
                      check.textInstanceResults.some(
                        (result) =>
                          result.variableOptionInstance.riskLevel === 1
                      )
                  )
                  .map((check, index) => (
                    <div className="summary-result-single" key={index}>
                      <div className="summary-result-l">
                        <Typography
                          sx={{
                            display: "flex",
                            gap: "8px",
                            alignItems: "center",
                            fontSize: "16px",
                            fontWeight: 500,
                          }}
                          component="span"
                        >
                          <Warning />
                          <span>{t(`check.${check.name}`)}</span>
                        </Typography>
                        {check.textInstanceResults.length !== 0 && (
                          <span className="summary-check-result">
                            {i18n.language === "nl"
                              ? check.variableResult?.summaryNL ||
                                t("nietGevonden")
                              : check.variableResult?.summaryEN ||
                                t("nietGevonden")}
                          </span>
                        )}
                      </div>
                      <div className="summary-result-r">
                        <span
                          className="check-redirect warning"
                          onClick={() => setSelectedCheck(check)}
                        >
                          {t("klikVoorDetails")}
                        </span>
                      </div>
                    </div>
                  ))}
              </div>
            </AccordionDetails>
          </Accordion>
        </div>
      </div>

      <div className="summary-container-r">
        <div className="summary-guidance">
          <Typography
            sx={{
              color: "#439BD9",
              fontWeight: "500",
              fontSize: "18px",
            }}
          >
            {t("Samenvatting")}
          </Typography>
          <Typography
            sx={{
              fontWeight: "400",
              fontSize: "14px",
              color: "#454545",
              lineHeight: "1.6",
            }}
          >
            {t("samenvattingText")}
          </Typography>

          <Typography
            sx={{ fontWeight: "500", fontSize: "14px", color: "#454545" }}
          >
            {t("uitlegRisiconiveaus")}
          </Typography>
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              gap: "24px",
              padding: "18px",
              background: "#F7FCFF",
              borderRadius: "8px",
            }}
          >
            <Box sx={{ display: "flex", flexDirection: "column", gap: "6px" }}>
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  gap: "8px",
                }}
              >
                <NoRisk />
                <Box sx={{ display: "flex", gap: "6px", alignItems: "center" }}>
                  <Typography sx={{ fontWeight: "500", fontSize: "14px" }}>
                    {t("Informatief")}
                  </Typography>
                </Box>
              </Box>
              <Box>
                <Typography
                  sx={{
                    color: "#5C5C5C",
                    fontSize: "14px",
                    fontWeight: "400",
                  }}
                >
                  {t("laagRisicoText")}
                </Typography>
              </Box>
            </Box>

            <Box sx={{ display: "flex", flexDirection: "column", gap: "6px" }}>
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  gap: "8px",
                }}
              >
                <Warning />
                <Box sx={{ display: "flex", gap: "6px", alignItems: "center" }}>
                  <Typography sx={{ fontWeight: "500", fontSize: "14px" }}>
                    {t("Let op")}
                  </Typography>
                </Box>
              </Box>
              <Box>
                <Typography
                  sx={{
                    color: "#5C5C5C",
                    fontSize: "14px",
                    fontWeight: "400",
                  }}
                >
                  {t("gemiddeldRisicoText")}
                </Typography>
              </Box>
            </Box>

            <Box sx={{ display: "flex", flexDirection: "column", gap: "6px" }}>
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  gap: "8px",
                }}
              >
                <Alert />
                <Box sx={{ display: "flex", gap: "6px", alignItems: "center" }}>
                  <Typography sx={{ fontWeight: "500", fontSize: "14px" }}>
                    {t("Pas op")}
                  </Typography>
                </Box>
              </Box>
              <Box>
                <Typography
                  sx={{
                    color: "#5C5C5C",
                    fontSize: "14px",
                    fontWeight: "400",
                  }}
                >
                  {t("hoogRisicoText")}
                </Typography>
              </Box>
            </Box>
          </Box>

          {/* {request?.licensePlate && (
            <div
              className="uploaded-doc"
              style={{ padding: "8px", borderRadius: "6px" }}
            >
              <DirectionsCarIcon sx={{ color: "#439BD9", fontSize: "24px" }} />
              <span
                style={{
                  fontSize: "14px",
                  color: "#454545",
                  fontWeight: 500,
                  border: "1px solid #439BD9",
                  padding: "2px 6px",
                  borderRadius: "4px",
                  backgroundColor: "#F7B731",
                  letterSpacing: "2px",
                }}
              >
                {request?.licensePlate}
              </span>
            </div>
          )} */}
        </div>

        {request?.adminComment && (
          <div className="summary-guidance">
            <div className="admin-comment-header">
              <h4>{t("Opmerkingen algemeen")} (1)</h4>
              <FeedbackIcon sx={{ color: "#439BD9", fontSize: "20px" }} />
            </div>
            <div className="admin-comment-from">
              <div className="vwc-avatar">
                <img src={logo} alt="VWC Logo" />
              </div>
              <span>Team Voorwaarden Checker</span>
            </div>
            <div className="admin-comment-text">
              <span style={{ whiteSpace: "pre-wrap" }}>
                {request?.adminComment || ""}
              </span>
            </div>
          </div>
        )}

        <div className="geen-risico-box">
          <h4>
            {t("Geen risico")} (
            {
              checks.filter(
                (check) =>
                  check.textInstanceResults.length !== 0 &&
                  check.textInstanceResults.some(
                    (result) => result.variableOptionInstance.riskLevel === 0
                  )
              ).length
            }
            )
          </h4>
          {checks
            .filter(
              (check) =>
                check.textInstanceResults.length !== 0 &&
                check.textInstanceResults.some(
                  (result) => result.variableOptionInstance.riskLevel === 0
                )
            )
            .map((check, index) => (
              <Accordion
                key={index}
                sx={{
                  boxShadow: "none",
                  background: "none",
                  "&.MuiAccordion-root:before": {
                    display: "none",
                  },
                  "& .MuiAccordionSummary-root": {
                    borderBottom: "none",
                  },
                }}
                disableGutters
              >
                <AccordionSummary
                  expandIcon={<ExpandMoreIcon sx={{ color: "#454545" }} />}
                  aria-controls="panel1-content"
                  id="panel1-header"
                  sx={{ padding: 0 }}
                >
                  <Typography
                    sx={{
                      display: "flex",
                      gap: "12px",
                      alignItems: "center",
                      fontSize: "16px",
                      fontWeight: 500,
                    }}
                    component="span"
                  >
                    <NoRisk />
                    <span> {t(`check.${check?.name || ""}`)}</span>
                  </Typography>
                </AccordionSummary>
                <AccordionDetails
                  sx={{
                    display: "flex",
                    flexDirection: "column",
                    gap: "16px",
                    padding: "8px 0px",
                  }}
                >
                  {check.textInstanceResults.length !== 0 && (
                    <span className="summary-check-result">
                      {i18n.language === "nl"
                        ? check.variableResult?.summaryNL || t("nietGevonden")
                        : check.variableResult?.summaryEN || t("nietGevonden")}
                    </span>
                  )}
                  <span
                    className="check-redirect no-risk"
                    onClick={() => setSelectedCheck(check)}
                  >
                    {t("klikVoorDetails")}
                  </span>
                </AccordionDetails>
              </Accordion>
            ))}
        </div>
      </div>
    </div>
  );
};

export default DemoSummary;
